import Control from '@/Controls/Control';
import { IAsyncElementProvider, IAsyncTupleProvider } from '#/DefaultViewExtensionInterfaces';
import ControlTuple from '@/Controls/ControlTuple';

export default abstract class AsyncControl extends Control implements IAsyncElementProvider, IAsyncTupleProvider<ControlTuple> {
    public getControl(): JQuery {
        throw new Error(`'getControl' is not supported in '${ this.constructor?.name ?? 'AsyncControl' }'`);
    }

    public abstract getElementAsync(): Promise<JQuery>;

    public async getTupleAsync(): Promise<ControlTuple> {
        if (this.tuple)
            return this.tuple;

        const $control = await this.getElementAsync();
        this.addDisposeCallback($control);
        this.tuple = new ControlTuple($control);
        return this.tuple;
    }
}